import { useState } from "react";
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "../ui/collapsible";
import { ChevronDown } from "lucide-react";

const isDesktop = () => typeof window !== "undefined" && window.innerWidth >= 768;

export default function SheetSection({ title, testId, alwaysOpen = false, children }) {
  const [open, setOpen] = useState(alwaysOpen || isDesktop());

  if (alwaysOpen) {
    return (
      <div>
        <p className="text-xs uppercase tracking-wider text-[#D4AF37]/70 mb-2 font-display">{title}</p>
        {children}
      </div>
    );
  }

  return (
    <Collapsible
      open={open}
      onOpenChange={setOpen}
      className="rounded-lg overflow-hidden bg-gradient-to-b from-[#322216] to-[#2a1c12] border-2 border-[#4a3424] border-b-[#1a1008] border-r-[#1a1008] shadow-[inset_0_0_12px_#180f08,0_4px_10px_rgba(0,0,0,0.4)]"
    >
      <CollapsibleTrigger
        data-testid={testId}
        className="w-full flex items-center justify-between px-3 py-2.5 text-xs uppercase tracking-wider text-[#D4AF37]/80 hover:text-[#D4AF37] font-display transition-colors duration-200 border-t border-t-[#D4AF37]/25"
      >
        {title}
        <ChevronDown className={`w-3.5 h-3.5 transition-transform duration-200 ${open ? "rotate-180" : ""}`} />
      </CollapsibleTrigger>
      <CollapsibleContent className="px-3 pb-3 pt-1 space-y-2">{children}</CollapsibleContent>
    </Collapsible>
  );
}
